<script>
import PersonThumb from "../lib/person-thumb.vue"

export default {
  components: {PersonThumb},
  props: {
    staff: {type: Object, required: true},
  },

  computed: {
    contactUrl() {
      return this.staff.uuid ? `/community/${this.staff.uuid}` : null
    }
  },
}
</script>

<template>
  <person-thumb
    :name="`${staff.first_name} ${staff.last_name}`"
    :image-url="staff.profile_image"
    :job-title="staff.job_title || ''"
    :company="staff.company_name || ''"
    :to="contactUrl"
  />
</template>
